// import CandidateInfo from "./pages/CandidateInfo";
// import SchoolInfo from "./pages/SchoolInfo";
// import Alcohol from "./pages/Alcohol";
// import VapeView from "./pages/VapeView";
// import DrugsView from "./pages/DrugsView";
// import BACView from "./pages/BACView";
// import Alcohol2View from "./pages/Alcohol2View";
// import Risk from "./pages/Risk";
// import Abuse from "./pages/Abuse";
// import AlcoholIntercourseView from "./pages/AlcoholIntercourseView";

const colors = {
    primary: '#000000',
    background: '#D3EEFF'
}

// const components = [
//     {
//         title:"candidateInfo",
//         view: <CandidateInfo />,
//     },
//     {
//         title:"schoolInfo",
//         view: <SchoolInfo />,
//     },
//     {
//         title:"vape",
//         view: <VapeView />,
//     },
//     {
//         title:"drugs",
//         view: <DrugsView />,
//     },
//     {
//         title:"bac",
//         view: <BACView />,
//     },
//     {
//         title:"alcohol",
//         view: <Alcohol />,
//     },
//     {
//         title:"alcohol2",
//         view: <Alcohol2View />,
//     },
//     {
//         title:"intercourse",
//         view: <AlcoholIntercourseView />,
//     },
//     {
//         title:"risk",
//         view: <Risk />,
//     },
//     {
//         title:"abuse",
//         view: <Abuse />,
//     },
// ];

export default colors;
// export { components };